<template>
    <div class="templete_box">
        <div class="templete">
            <div class="search_box clearfix">
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="起始日期"></el-date-picker>
                    ~
                    <el-date-picker v-model="end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
                </div>
                <el-select class="search_select search_inputBox" v-model="params.search.payee" placeholder="服务商名称" @visible-change="getSelectList('servers')">
                    <el-option v-for="list in selectMap.servers" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.search.creator_id" placeholder="制单人" @visible-change="getCreator">
                    <el-option v-for="list in creater" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-model="params.search.contract_no" placeholder="合同号"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.search.bill_lading_no" placeholder="提单号"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.search.order_sn" placeholder="销售单号"></el-input>
                <el-select class="search_select search_inputBox" v-model="params.search.fee_id" placeholder="费用名称" @visible-change="getSelectList('feeType')">
                    <el-option v-for="list in selectMap.feeType" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.search.pay_status" placeholder="付款状态">
                    <el-option v-for="list in statusList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <div class="searchBtnList clearfix">
                    <div class="reset fcolor" @click="reset">重置</div>
                    <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                </div>
            </div>
            <div class="btnList clearfix">
                <el-button class="funcPublicBtn funcPublicBtnChecked" @click="pass" v-if="module.indexOf(',finance-fee-review-pass,')!=-1">审核通过</el-button>
                <el-button class="funcPublicBtn" @click="refuseFunc" v-if="module.indexOf(',finance-fee-review-pass,')!=-1">审核拒绝</el-button>
            </div>
            <div class="tableBox">
                <tabletem :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow" @rowClick="rowClick" @hoverClick="hoverClick"></tabletem>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
        </div>
        <!--拒绝原因START-->
        <el-dialog v-dialog-drag title="拒绝原因" :visible.sync="centerDialogVisible" width="500px" class="eldialog eldialogA" :model="false">
            <textarea class="edit_input edit_textarea" v-model="refuse.refuse_remark" placeholder="请输入拒绝原因"></textarea>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn"  @click="confirmRefuseRemark">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="centerDialogVisible = false">取消</el-button>
            </div>
		</el-dialog>
        <!--拒绝原因END-->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleHoverClick" class="eldialog eldialogOneLabel" width="400px" :modal="false" :title="hoverClickObj.title" custom-class="full_dialog">
            <div class="">
                <el-form>
                    <el-form-item :label="hoverClickObj.title+':'">
                        <el-input class="edit_input" v-model="hoverClickObj.val" placeholder=""></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn" @click="hoverClickConfirm">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="dialogVisibleHoverClick = false">取消</el-button>
            </div>
        </el-dialog>
        <saledetail :dialogVisiblesale="dialogVisibleSale" :id="saleDetailId" @close="()=>{this.saleDetailId = false;}"></saledetail>
    </div>
</template>
<script>
    import tabletem from '../../components/table.vue'
    import pagination from '../../components/pagination.vue'
    import saledetail from '../../components/saleDetail.vue'
    export default {
        data(){
            return{
                saleDetailId:"",
                dialogVisibleSale:false,
                tableLoading:false,
                dialogVisibleHoverClick:false,
                hoverClickObj:{
                    id:"",
                    title:"",
                    val:"",
                    posturl:"",
                    key:""
                },
                module:localStorage.dw_erp_power_code,
                boardAmericaType:localStorage.dw_erp_board.indexOf("board-america")!=-1?true:false,
                boardAfricaType:localStorage.dw_erp_board.indexOf("board-africa")!=-1?true:false,
                start_time:"",
                end_time:new Date(),
                params:{
                    search:{
                        start_time:"",
                        end_time:"",
                        payee:"",
                        creator_id:"",
                        contract_no:"",
                        bill_lading_no:"",
                        fee_id:"",
                        order_sn:"",
                        pay_status:""
                    },
                    page:1,
                    per_page:50
                },
                last_page:1,
                total:0,
                selectRow:[],
                selectMap:{
                    customer:[],
                    feeType:[],
                    creater:[],
                    servers:[]
                },
                creater:[],
                statusList:[
                    {id:999,name:"全部状态"},
                    {id:1,name:"未支付"},
                    {id:2,name:"已支付"}
                ],
                list:[],
                tableCol:[	
                    {colName:"添加日期",colKey:"fee_date",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"审核状态",colKey:"auditor_status_text",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"费用类型",colKey:"source_type_text",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"费用名称",colKey:"fee_name",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"费用金额",colKey:"amount",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"是否开票",colKey:"is_invoice_text",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"服务商名称",colKey:"payee",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"付款状态",colKey:"pay_status_text",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"发票状态",colKey:"invoice_status_text",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"费用单号",colKey:"fee_sn",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"关联合同号",colKey:"contract_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"关联提单号",colKey:"bill_lading_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"关联货柜号",colKey:"container_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"关联销售单号",colKey:"order_sn",colWidth:170,isSetWidth:true,isCanClick:true,isShow:true,isColor:true},
                    {colName:"制单人",colKey:"creator_name",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isHoverClick:true},


                    // {colName:"费用单号",colKey:"fee_sn",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"合同号",colKey:"contract_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"提单号",colKey:"bill_lading_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"审核状态",colKey:"auditor_status_text",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"支付状态",colKey:"pay_status_text",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"费用名称",colKey:"fee_name",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true}, 
                    // {colName:"金额",colKey:"amount",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"服务商",colKey:"payee",colWidth:140,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"开票状态",colKey:"invoice_status_text",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // // {colName:"制单员",colKey:"creator_name",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"货柜号",colKey:"container_no",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"费用日期",colKey:"fee_date",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"审核员",colKey:"auditor_name",colWidth:95,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"审核日期",colKey:"audit_time",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                ],
                totalObj:{},
                refuse:{
                    ids:[],
                    refuse_remark:""
                },
                centerDialogVisible:false,
            }
        },
        created(){
            this.getList()
        },
        methods:{
            hoverClickConfirm(){
                let obj = new Object();
                obj.id = this.hoverClickObj.id;
                obj[this.hoverClickObj.key] = this.hoverClickObj.val;
                this.postFuncLoading(this.hoverClickObj.posturl,obj,()=>{
                    this.tip("修改成功","success")
                    this.getList()
                    this.dialogVisibleHoverClick = false;
                })
            },
            hoverClick(row){
                this.hoverClickObj.id = row.id;
                if(row.hoverClickName == 'remark'){
                    this.hoverClickObj.val = row.remark;
                    this.hoverClickObj.title = "备注";
                    this.hoverClickObj.posturl = "/erp/fee.review.remark";
                    this.hoverClickObj.key = "remark";
                }
                this.dialogVisibleHoverClick = true;
            },
            refuseFunc(){
                if(this.selectRow.length <= 0){
                    this.tip("请选择数据","warning")
                    return;
                }else{
                    let arr = new Array();
                    this.selectRow.forEach(item=>{
                        arr.push(item.id)
                    })
                    this.refuse.ids = arr;
                    this.centerDialogVisible = true;
                }
            },
            //拒绝审核通过
            confirmRefuseRemark(){
                this.$confirm('是否确认拒绝?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFuncLoading("/erp/fee.review.refuse",this.refuse,()=>{
                        this.tip('拒绝成功','success');
                        this.centerDialogVisible=false;
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            getCreator(){
                this.postFunc("/erp/fee.creators",{},res=>{
                    this.creater = res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            pass(){
                if(this.selectRow.length<1){
                    this.tip("请选择数据","warning")
                }else{
                    let arr = new Array();
                    this.selectRow.forEach(item=>{
                        arr.push(item.id)
                    })
                    this.$confirm('是否通过?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.postFuncLoading("/erp/fee.review.pass",{ids:arr},()=>{
                            this.tip("操作成功","success")
                            this.getList()
                        },error=>{
                            this.tip(error.data.message,"warning")
                        })
                    }).catch(()=>{});
                }
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            reset(){
                this.start_time="",
                this.end_time=new Date(),
                this.params={search:{start_time:"",end_time:"",payee:"",creator_id:"",contract_no:"",bill_lading_no:"",fee_id:"",pay_status:""},page:1,per_page:50}
                this.getList();
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.params.search.start_time=this.formatTimeZero(this.start_time)
                this.params.search.end_time=this.formatTimeZero(this.end_time)
                this.tableLoading = true;
                this.postFunc("/erp/fee.review",this.params,res=>{
                    this.last_page=parseInt(res.data.data.last_page);
                    // this.params.page=parseInt(res.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.total);
                    this.list=res.data.data.list;
                    this.list.forEach((item,index)=>{
                        item.isDelete=false;
                        item.idEdit=false;
                        item.baseColor = "#ff0000"
                        if(item.fee_date!=0){
                            this.list[index].fee_date = this.formatTime(item.fee_date+"000")
                        }
                        if(item.audit_time!=0){
                            this.list[index].audit_time = this.formatTime(item.audit_time+"000")
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },

            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            rowClick(obj){
                this.list.forEach(item=>{
                    if(item.id == obj.id){
                        this.dialogVisibleSale=true
                        this.saleDetailId = item.order_id;
                    }
                })
            },
            getRow(row){
                this.selectRow=row;
            },
        },
        components:{
            tabletem,
            pagination,
            saledetail
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "centerDialogVisible":function(val){
                if(!val){
                    this.refuse = {id:[],refuse_remark:""}
                }
            }
        }
    }
</script>
<style scoped lang="scss">
</style>
